"use client"

import type { AcquisitionCampaignFields } from "@/lib/attribution/acquisition-channel"
import { hasPaidAcquisitionFields } from "@/lib/attribution/acquisition-channel"

const STICKY_ACQUISITION_KEY = "attribution_sticky_acquisition"

function safeGetLocalStorage(): Storage | null {
  if (typeof window === "undefined") return null
  try {
    return window.localStorage
  } catch {
    return null
  }
}

export function readStickyAcquisitionCampaign(): AcquisitionCampaignFields | null {
  const storage = safeGetLocalStorage()
  if (!storage) return null

  const raw = storage.getItem(STICKY_ACQUISITION_KEY)
  if (!raw) return null

  try {
    const parsed = JSON.parse(raw) as AcquisitionCampaignFields
    if (!parsed || typeof parsed !== "object") return null
    return hasPaidAcquisitionFields(parsed) ? parsed : null
  } catch {
    return null
  }
}

export function persistStickyAcquisitionCampaign(fields: AcquisitionCampaignFields): void {
  if (!hasPaidAcquisitionFields(fields)) return

  const storage = safeGetLocalStorage()
  if (!storage) return

  try {
    storage.setItem(STICKY_ACQUISITION_KEY, JSON.stringify(fields))
  } catch {
    // quota / modo privado
  }
}

export function acquisitionFieldsFromUtmLike(input: {
  source?: string | null
  medium?: string | null
  campaign?: string | null
  content?: string | null
  term?: string | null
  gclid?: string | null
  fbclid?: string | null
  ttclid?: string | null
}): AcquisitionCampaignFields {
  return {
    source: input.source ?? null,
    medium: input.medium ?? null,
    campaign: input.campaign ?? null,
    content: input.content ?? null,
    term: input.term ?? null,
    gclid: input.gclid ?? null,
    fbclid: input.fbclid ?? null,
    ttclid: input.ttclid ?? null,
  }
}
